export default __webpack_public_path__ + "static/1349-bcc79b4606f061adb0d1223f136f5d34.gif";